import { BulkDeleteWithConfirmButton } from 'react-admin';

export const ListBulkActions = () => {
  return <BulkDeleteWithConfirmButton mutationMode={'pessimistic'} />;
};
